// extracted by mini-css-extract-plugin
export default {"popover":"ReceiptMenu_popover__XvNRZ","modal__header":"ReceiptMenu_modal__header__1xDKy"};